<nav #navbar class="navbar no-view">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink="dashboard/main">
        <img src="assets/images/logos/hb_logo_negativo_new.svg" class="w-logo" alt="" />
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <i class="nav-hdr-btn ti-align-left"></i>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Mode ligth -->
        <li class="fullscreen">
          <button mat-icon-button (click)="modeTheme('ligth')" class=" nav-notification-icons">
            <i class="nav-hdr-btn ti-shine"></i>
          </button>
        </li>
        <!-- Mode Nigth -->
        <li class="fullscreen">
          <button mat-icon-button (click)="modeTheme('nigth')" class=" nav-notification-icons">
            <i class="nav-hdr-btn ti-cloud"></i>
          </button>
        </li>
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
            <i class="nav-hdr-btn ti-fullscreen"></i>
          </button>
        </li>
<!--        <li class="nav-item" ngbDropdown>-->
<!--          <a ngbDropdownToggle class="lang-dropdown">-->
<!--            <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" height="16"> <span class="country-name">{{countryName}}</span>-->
<!--            <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" height="16"> <span *ngIf="flagvalue === undefined" class="country-name">English</span>-->
<!--          </a>-->
<!--          <div ngbDropdownMenu class="dropdown-menu lang-item dropdown-menu-right pullDown">-->
<!--            <a href="javascript:void(0);" class="dropdown-item lang-item-list" *ngFor="let item of listLang"-->
<!--              (click)="setLanguage(item.text, item.lang, item.flag)"-->
<!--              [ngClass]="{'active': langStoreValue === item.lang}">-->
<!--              <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>-->
<!--            </a>-->
<!--          </div>-->
<!--        </li>-->
        <!-- <li class="nav-item" ngbDropdown>
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons" (click)="viewNotification()">
            <i class="nav-hdr-btn ti-bell"></i> -->
<!--            <span class="notify"></span>-->
<!--            <span class="heartbeat"></span>-->
          <!-- </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <li *ngIf="notificationList">
                  <a *ngFor="let notification of notificationList" (click)="goRoute(notification?.id)">
                    <span class="menu-info">
                      <span class="menu-desc">
                        <i class="material-icons">access_time</i> {{dateFormated(notification.occurrenceDate)}}
                      </span>
                      <span class="menu-title">{{notification?.type}} - {{notification?.description | slice: 0:50}}...</span>
                      <br>
                    </span>
                  </a>
                  <a class="text-center d-block border-top py-1" onClick="return false;" *ngIf="notificationList.length === 0"> Sem Notifiçãoes</a>
                  <a class="text-center d-block border-top py-1" routerLink="/notifications">Ver Todos</a>
                </li>
              </ul>
            </div> -->
<!--            <a class="text-center d-block border-top py-1" href="#" onClick="return false;"> Read All Notifications</a>-->
          <!-- </div>
        </li> -->
        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
            <img
                [src]="
                  authService.currentUserValue &&
                  authService.currentUserValue.photoURL
                    ? authService.currentUserValue.photoURL
                    : 'assets/images/user.jpg'
                "
                class="rounded-circle" width="32" height="32" alt="User"
              />
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <!-- <li>
                      <a routerLink="/profile" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>Perfil
                      </a>
                    </li> -->
                    <!-- <li *ngIf="checkUsertype()">
                      <a (click)="openDialogVersions()">
                        <mat-icon aria-hidden="false" class="mr-2">upgrade</mat-icon>Versões
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()">
                        <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>Logout
                      </a>
                    </li>
                    <li class="text-center text-small">
                      {{environment.name}}: {{version}}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons">
            <i class="nav-hdr-btn ti-layout-grid2" id="settingBtn"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>>
